
let isBrowserBackForword = false;
//ブラウザバック、ブラウザフォワードを検知する
//vue routerが設定する同じ'popstate'イベントよりも先に登録が必要なので、本ファイルの開始時点で登録する
window.addEventListener('popstate', () => {
  isBrowserBackForword = true;
})

import { createWebHistory, createRouter, RouteLocationNormalized,  NavigationGuardNext, NavigationFailure } from "vue-router";

//使用頻度の高い画面は最初から取り込んでおく
//（遅延ロードについて、VueCLI環境だと効果がなく初期ロードでほとんど全ての「x.js」が読み込まれるが、Spring bootに配置すると必要な「x.js」のみ読み込まれる）
import Home from '@/pages/Home.vue'
import PublicPage from './pages/publicPage/PublicPage.vue'


export const LOGIN_PAGE = "/login";

const routes = [
  {
    path: '/',
    meta: {
      title: "forkstyle"
    },
    //本体バンドルに含める
    component: Home
  },
  {
    path: '/upload/:uploadTabName/:projectId?/:publicPageId?',
    meta: {
      //title: "ファイルアップロード"
    },
    component: () => import('./pages/upload/Upload.vue')
  },
  {
    path: LOGIN_PAGE,
    meta: {
      title: "ログイン"
    },
    component: () => import('@/pages/Login.vue')
  },
  {
    path: '/account/:accountTabName?',
    meta: {
      title: "アカウント",
      requiresAuth: true
    },
    component: () => import('./pages/account/Account.vue')
  },
  {
    path: '/forgot/password',
    meta: {
      title: "パスワード再設定",
    },
    component: () => import('./pages/forgot/Password.vue')
  },
  {
    path: '/forgot/password/change',
    meta: {
      title: "パスワード再設定",
    },
    component: () => import('./pages/forgot/PasswordChange.vue')
  },

  {
    path: '/signup',
    meta: {
      title: "ユーザ登録",
    },
    component: () => import('./pages/signup/Signup.vue')
  },
  {
    path: '/signup2',
    meta: {
      title: "ユーザ登録",
    },
    component: () => import('./pages/signup/Signup2.vue')
  },
  {
    path: '/signup/activate',
    meta: {
      title: "ユーザ情報入力",
    },
    component: () => import('./pages/signup/Activate.vue')
  },

  {
    path: '/search/:searchTabName?',
    meta: {
    },
    component: () => import('./pages/search/Search.vue')
  },
  {
    path: "/about/:aboutFirst(api|collaboration|compare|debug|api-key|limitation|dummy-code|tutorial|tutorial-ai|security-detection|security-tampering)?/:aboutSecond?",
    meta: {
      title: "forkstyleについて",
    },
    component: () => import("./pages/about/Index.vue"),
    //aboutで多重childrenは使用しない。
    //aboutを開いたら関連情報を一緒にダウンロードしたいため。
    // children: [
    //   {}
    // ]
  },
  {
    path: "/programming-course/:courseFirst?",
    meta: {
      title: "プログラミングコースについて",
    },
    component: () => import("./pages/programming-course/Index.vue"),
  },
  {
    path: '/:userName/',
    component: () => import('./pages/user/User.vue')
  },
  {
    path: '/:userName/:publicPageTitle',
    //本体バンドルに含める
    component: PublicPage
  },
  {
    //vue routerは並び順でマッチ優先度が決まるので最後に定義する 
    path: '/:pathMatch(.*)*',
    component: () => import('./pages/NotFound.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


let previousRoute: RouteLocationNormalized | null = null;
const scrollYHistory = {} as {[path:string]:number};
router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next:NavigationGuardNext) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title as any;
  }

  //最初の画面表示時にもbeforeEachが実行されるが、matchedがないので、その場合を除外する
  if (from.matched && from.matched.length > 0) {
    previousRoute = from;
  }
  next();

  scrollYHistory[from.fullPath] = window.scrollY;
})
router.afterEach((to: RouteLocationNormalized, _from: RouteLocationNormalized, _failure:NavigationFailure | void)=>{
  if(isBrowserBackForword){
    isBrowserBackForword = false
    //元に戻る先のページにrouter-linkなど微妙に別イベントで動作する（と思われる）ものがある場合、ちゃんと動かない可能性がある
    window.scrollTo(0, scrollYHistory[to.fullPath] || 0);
  }else{
    window.scrollTo(0, 0);
  }
})


export const getPreviousRoute = () => {
  return previousRoute;
}
// export const getPrevNoAuthPage = () => {
//   return prevNoAuthPage;
// }

// export const backPage = (isLogin:boolean) => {
//   const prevPage = getPrevPage();
//   const prevNoAuthPage = getPrevNoAuthPage();

//   //現在ログイン済の場合、もしくは、前のページがログイン不要の場合、前のページへ戻る
//   if(isLogin || (prevPage && prevPage === prevNoAuthPage)){
//     router.back();
//   //直近のログイン不要ページへ戻る
//   }else if(prevNoAuthPage){ 
//     router.push(prevNoAuthPage.path);
//   //Homeへ移動
//   }else{
//     router.push("/");
//   }
// }





//このオブジェクトは、.vueファイル中のthis.$router === routerとなる。（main.tsでRootVueに含めるため）
//そういう前提で、.tsファイルからこのrouterを直接読み込んで良いとする。
export default router
